import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "p-color-pallet-grid-item" }
const _hoisted_2 = { class: "p-color-pallet-scale-group u-flex-center-stretch" }
const _hoisted_3 = { class: "p-color-pallet-label" }
const _hoisted_4 = ["data-code"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "p-color-pallet-sign" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "__text" }, "view details")
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "p-color-pallet-card",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDetails()))
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propsColor.code, (hex, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `${String(_ctx.propsColor.id)}_${String(index)}`,
            class: "p-color-pallet-scale-item u-flex-shrink-1"
          }, [
            _createElementVNode("span", {
              class: "__element",
              style: _normalizeStyle({background: hex})
            }, null, 4 /* STYLE */)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          class: "__number",
          "data-code": _ctx.propsColor.id
        }, null, 8 /* PROPS */, _hoisted_4)
      ]),
      _hoisted_5
    ])
  ]))
}